const ipsAll = [];

ipsAll.push({
  ips: ['daxin.dzfpxt.com'],
  modeDes: '大新-互联网', // ssl+域名
  webhost: 'https://daxin.dzfpxt.com',
  hostIp:  'https://daxin.dzfpxt.com/web_api',
  imgHostIp: 'https://daxin.dzfpxt.com/images',
  loginType: 'password',
  authClientId: '',
  localStorage: 'RoomTicket/tokenDaxin',
  hostName: '大新镇',
});


ipsAll.push({
  ips: ['localhost'],
  modeDes: '大新-互联网', // ssl+域名
  webhost: 'http://localhost:3000',
  hostIp:  'https://daxin.dzfpxt.com/web_api',
  imgHostIp: 'https://daxin.dzfpxt.com/images',
  loginType: 'password',
  authClientId: '',
  localStorage: 'RoomTicket/tokenDaxin',
  hostName: '大新镇',
});


ipsAll.push({
  ips: ['120.27.158.247'],
  modeDes: '大新-互联网', // ssl+域名
  webhost: 'http://120.27.158.247:3000',
  hostIp:  'https://120.27.158.247/web_api',
  imgHostIp: 'https://120.27.158.247/images',
  loginType: 'password',
  authClientId: '',
  localStorage: 'RoomTicket/tokenDaxin',
  hostName: '大新镇',
});

export {
  ipsAll
};
